export default "__VITE_ASSET__Daw$JdKL__"